import { Module } from 'vuex';

import { RootStateI } from '../state';
import { state, PatientStateI } from './state';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const module: Module<PatientStateI, RootStateI> = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
};

export default module;
